class ReceiptNote {
    id = null;
    number = '';
    time_of_issue = null;
    currency = '';
    currency_rate = 1;
    user_id = null;
    supplier_id = null;
    supplier_data = {};
    sequence = 0;
    receipt_note_sequence_id = null;
    hash = '';
    items = [];
    locale = '';
    incoming_invoice_number = '';
    cancels = 0;
    cancelled_by = 0;

    constructor(data, validation = false) {
        this.currency = 'EUR';

        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default ReceiptNote;
